export default "__VITE_ASSET__DXDhtbGS__"